import React from 'react'
import { Redirect, Switch } from 'react-router-dom'
import { Route } from 'react-router-dom'
import NoPage from '../Containers/Pages/Static/NoPage'
import BlogDetails from '../Containers/Pages/Static/blogDetails'
import EngagmentStaticPage from '../Containers/Pages/EngagementLandingPage/EngagmentStaticPage'

function Redirection() {
  return (

    <Switch>
       <Route path="/engagement-rings-toronto/solitaires" render={() => (<Redirect to="/ringsettings/Solitaire" />)} />
      <Route path="/engagement-rings-toronto/side-stones" render={() => (<Redirect to="/ringsettings/Side%20stone" />)} />
      <Route path="/engagement-rings-toronto/halo" render={() => (<Redirect to="/ringsettings/Halo" />)} /> 
      {/* <Route path="/coloured-diamonds" render={() => (<Redirect to="/fancy-color-diamond" />)} /> */}
      <Route path="/engagement-rings-toronto/3-stones" render={() => (<Redirect to="/ringsettings/Three%20stone" />)} /> 
      <Route path="/education-2" render={() => (<Redirect to="/education-diamonds" />)} />
      <Route path="/education-2/4cs-diamond-buying-guide" render={() => (<Redirect to="/education-diamonds" />)} />
      <Route path="/education-2/dos-and-donts" render={() => (<Redirect to="/education-diamonds" />)} />
      <Route path="/category/certified-diamonds" render={() => (<Redirect to="/blog" />)} />
      <Route path="/category/engagement-rings" render={() => (<Redirect to="/blog" />)} />
      <Route path="/category/engagement-rings/page/2" render={() => (<Redirect to="/blog" />)} />
      <Route path="/warranty-registration-1" render={() => (<Redirect to="/warranty" />)} />
      <Route path="/warranty-registration-2" render={() => (<Redirect to="/warranty" />)} />
      <Route exact path="/engagement-rings-toronto" component={EngagmentStaticPage} />

      <Route path='/:url' component={BlogDetails} />
       <Route path='*' exact={true} component={Redirection} />

    </Switch>
  )
}

export default Redirection